import React from 'react'
import { Collapse } from 'antd';
import { motion } from "framer-motion";
import ytPlayBtn from "../../../../../assets/images/YouTube_play_button.svg";



export const DynamicTab = ({ responseData,transformedData,PlayVideoHandler,loading,CompLoader,color,convertToStandardURL,PlayVimeoVideoHandler }) => {
    return (
          <div className="rowBody preview-container preview-tab-container">
                            {loading ? (
                              <CompLoader />
                            ) : 
                              responseData &&
                              responseData?.length > 0 ? (
                              <Collapse accordion>
                                {transformedData.map((team, index) => (
                                  <Collapse.Panel
                                    className="collapsePanelWidth"
                                    key={`${team.id}-${team.assetTitle}`}
                                    header={team.assetTitle}
                                    style={{
                                      width: "360px",
                                      backgroundColor: "white",
                                      marginBottom: "10px",
                                      minHeight: "16%",
                                      borderRadius: 10,
                                      boxShadow: "1px 1px 1px rgba(0, 0, 0, 0.2)",
                                      fontSize: "1.25em",
                                      fontWeight: "500",
                                      paddingTop: 8,
                                      paddingBottom: 8,
                                      marginLeft: "1px",
                                      borderLeft: `5px solid ${color[index % 7]}`,
                                    }}
                                  >
                                    {team?.subTitles?.map((data, i) => (
                                      <motion.div
                                        key={i}
                                        initial={{ opacity: 0, scale: 0.5 }}
                                        animate={{ opacity: 1, scale: 1 }}
                                        transition={{
                                          duration: 0.8,
                                          delay: 0.5,
                                          ease: [0, 0.71, 0.2, 1.01],
                                        }}
                                      >
                                        <div
                                          style={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                            cursor: "pointer",
                                            borderRadius: "10px",
                                            borderLeft: "5px solid #ccc",
                                          }}
                                        >
                                          <div
                                            style={{
                                              marginLeft: 24,
                                              fontWeight: 400,
                                            }}
                                          >
                                            {data?.subTitle}
                                          </div>
                                          <div className="gutter-row" span={9}>
                                            {data.mediaLink?.mediaType ===
                                              "SOCIAL_MEDIA" ? (
                                              <div
                                                className="sliderImg videoOverlay"
                                                onClick={PlayVideoHandler.bind(
                                                  this,
                                                  data.mediaLink?.url,
                                                  data.mediaLink?.mediaType
                                                )}
                                              >
                                                {(() => {
                                                  const standardURL =
                                                    convertToStandardURL(
                                                      data.mediaLink?.url
                                                    );
                                                  const videoID = new URLSearchParams(
                                                    new URL(standardURL).search
                                                  ).get("v");
                                                  return (
                                                    <>
                                                      <img
                                                        src={`https://img.youtube.com/vi/${videoID}/hqdefault.jpg`}
                                                        style={{
                                                          objectFit: "cover",
                                                        }}
                                                        alt=""
                                                        className="video-preview-image"
                                                      />
                                                      <img
                                                        className="ytBtnOverlay"
                                                        src={ytPlayBtn}
                                                        alt=""
                                                        onClick={() =>
                                                          PlayVideoHandler(
                                                            data.mediaLink?.url,
                                                            data.mediaLink?.mediaType
                                                          )
                                                        }
                                                      />
                                                    </>
                                                  );
                                                })()}
                                              </div>
                                            ) : data?.mediaLink?.mediaType ===
                                              "VIMEO_MEDIA" ? (
                                              <div
                                                className="sliderImg videoOverlay"
                                                onClick={PlayVimeoVideoHandler.bind(
                                                  this,
                                                  data.mediaLink?.url,
                                                  data.mediaLink?.mediaType
                                                )}
                                              >
                                                <img
                                                  src={`https://vumbnail.com/${data.mediaLink.url.split("/")[4]
                                                    }.jpg`}
                                                  alt=""
                                                  className="video-preview-image"
                                                />
                                                <img
                                                  className="ytBtnOverlay"
                                                  src={ytPlayBtn}
                                                  alt=""
                                                  onClick={PlayVideoHandler.bind(
                                                    this,
                                                    data.mediaLink?.url,
                                                    data.mediaLink?.mediaType
                                                  )}
                                                />
                                              </div>
                                            ) : data?.mediaLink?.mediaType ===
                                              "IMAGE" ? (
                                              <div className="sliderImg-alt">
                                                <img
                                                  src={data.mediaLink?.url}
                                                  alt=""
                                                  className="preview-img"
                                                />
                                              </div>
                                            ) : (
                                              <div className="sliderImg-alt">
                                                <div className="preview-img"></div>
                                              </div>
                                            )}
                                          </div>
                                        </div>
                                        {i !== team.subTitles.length - 1 && (
                                          <hr
                                            style={{
                                              border: "1px solid lightgray",
                                            }}
                                          />
                                        )}
                                      </motion.div>
                                    ))}
                                  </Collapse.Panel>
                                ))}
                              </Collapse>
                            ) : (
                              <div className="background-container">
                                <span>Nothing here at the moment</span>
                              </div>
                            )}
                          </div>
    )
}
